import React from 'react'
import { useTranslation } from '@sailor/i18n-web'
import styles from './index.module.less'
import Container from '../Container'
import HighlightText from '../HighlightText'
import ShopSvg from '../Icons/ShopSvg'
import ForkSvg from '../Icons/ForkSvg'
import RiderSvg from '../Icons/RiderSvg'
import CustomerServiceSvg from '../Icons/CustomerServiceSvg'
import MealTimeSvg from '../Icons/MealTimeSvg'

const ServiceCard = () => {
  const { t } = useTranslation()

  const diningCards = [
    {
      image: <ForkSvg />,
      title: t('ent_o_service_restaurant_resources', '餐厅资源'),
      count: t('ent_o_service_million_plus', '100万+'),
      description: t('ent_o_service_new_dining_mode', '打造企业用餐新模式'),
    },
    {
      image: <ShopSvg />,
      count: '15,000',
      title: t('ent_o_service_merchant_resources', '商户资源'),
      description: t('ent_o_service_dining_choices', '餐饮选择丰富'),
    },
    {
      image: <RiderSvg />,
      count: t('ent_o_service_rider_count', '2万+'),
      title: t('ent_o_service_active_riders', '活跃骑手'),
      description: t('ent_o_service_timely_delivery', '餐品及时送达'),
    },
    {
      image: <CustomerServiceSvg viewBox="-12 -12 72 72" />,
      count: '7*24h',
      title: t('ent_o_service_professional_team', '企服专业团队'),
      description: t('ent_o_service_professional_consulting', '提供专业服务咨询'),
    },
    {
      image: <MealTimeSvg />,
      count: '<30min',
      title: t('ent_o_service_avg_delivery_time', '送餐平均时间'),
      description: t('ent_o_service_no_miss_meal', '员工不在错过饭点'),
    },
  ]

  return (
    <>
      <Container style={{ paddingBottom: 0 }}>
        <div className={styles.container}>
          {/* 标题区域 */}
          <div className={styles.titleWrapper}>
            <h2 className="section-title">
              <span>{t('ent_o_title_our1', '我们的')}</span>
              <HighlightText textPosition="right">
                {t('ent_o_title_service_advantages1', '服务优势')}
              </HighlightText>
            </h2>
          </div>
        </div>
      </Container>
      <Container style={{ paddingTop: 0 }} contentClassName={styles.cardGridContainer}>
        <div className={`${styles.cardGrid} ${styles.cardAnimation}`}>
          {diningCards.map(item => (
            <div
              className={styles.card}
              role="button"
              tabIndex={0}
            >
              <div className={styles.iconWrapper} aria-hidden="true">
                {item.image}
              </div>
              <h3 className={styles.title}>
                {item.title}
              </h3>
              <div className={styles.value}>
                {item.count}

              </div>
              <p className={styles.description}>
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </>
  )
}

export default ServiceCard